import { Table, TableHeader, TableBody, TableCell, TableRow } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { TableItemRowDetails } from "../types";

interface Props {
  rows: TableItemRowDetails[];
}

const DataTable = ({ rows }: Props) => {
  const allColumns = rows.reduce((columns, row) => {
    const updatedHeadersSet = { ...columns };

    Object.keys(row).forEach((column) => {
      updatedHeadersSet[column] = "";
    });

    return updatedHeadersSet;
  }, {});

  return (
    <div css={{ marginBottom: SPACING.MEDIUM }}>
      <Table condensed variant="muted">
        <TableHeader>
          <TableRow>
            {Object.keys(allColumns).map((column) => (
              <TableCell header key={column}>
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHeader>
        {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
        {/* @ts-ignore */}
        <TableBody>
          {rows.map((row) => (
            // eslint-disable-next-line react/jsx-key
            <TableRow data-testid="request-details-row">
              {Object.keys(row).map((columnName) => {
                const columnData = row[columnName];
                return <TableCell key={columnName}>{columnData ?? "--"}</TableCell>;
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default DataTable;
